import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

const partners = [
  {
    id: "firestarter",
    href: "https://firestarter.com.au/",
    label: (
      <>
        <span className="text-[#241C17]">Fire</span>
        <span style={{ color: "#E85A24" }}>starter</span>
      </>
    ),
    img: "/partner-firestarter.png",
    alt: "Firestarter logo",
    imgCls: "h-16 w-16 rounded-full",
    tag: "Performance marketing & AI CRM",
  },
  {
    id: "liveswitch",
    href: "https://liveswitch.com.au/",
    img: "/partner-liveswitch.png",
    alt: "LiveSwitch logo",
    imgCls: "h-11 w-auto",
    tag: "Marketing systems for education & finance",
  },
];

export const Partners = () => (
  <section id="partners" data-testid="partners-section" className="bg-[#F2EDE6] py-20 sm:py-24">
    <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-16">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
        className="mb-12 text-center"
      >
        <p className="overline-tag mb-4" style={{ color: "#B01E28" }}>Partnerships</p>
        <h2 className="font-heading text-xl font-semibold tracking-tight text-[#1C1512] sm:text-2xl">
          Proudly in partnership <span className="font-display italic text-ruby">with</span>
        </h2>
      </motion.div>

      <div className="mx-auto grid max-w-4xl grid-cols-1 gap-6 sm:grid-cols-2">
        {partners.map((p, i) => (
          <motion.a
            key={p.id}
            href={p.href}
            target="_blank"
            rel="noopener noreferrer"
            data-testid={`partner-link-${p.id}`}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.7, delay: i * 0.1, ease: [0.16, 1, 0.3, 1] }}
            className="group flex flex-col items-center rounded-2xl border border-[#1C1512]/10 bg-white/70 px-8 py-10 text-center transition-all duration-500 hover:-translate-y-1 hover:border-ruby/40 hover:shadow-[0_20px_50px_rgba(28,21,18,0.12)]"
          >
            {p.label && (
              <span className="mb-5 font-brand text-2xl font-bold tracking-tight">{p.label}</span>
            )}
            <img src={p.img} alt={p.alt} className={`${p.imgCls} object-contain`} />
            <span className="mt-3 font-mono text-[10px] uppercase tracking-[0.25em] text-[#6B615A]">
              {p.tag}
            </span>
            <span className="mt-5 flex items-center gap-1.5 font-mono text-[10px] uppercase tracking-[0.2em] text-[#8A7F75] transition-colors duration-300 group-hover:text-ruby">
              Visit site
              <ArrowUpRight className="h-3 w-3 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </span>
          </motion.a>
        ))}
      </div>
    </div>
  </section>
);
